import { createAsyncThunk } from '@reduxjs/toolkit'
import * as markerNotificationsApi from '../../api/markerNotifications.api'
import * as bookingsApi from '../../api/bookings.api'

export const fetchMarkerNotifications = createAsyncThunk(
    'markerNotifications/fetch',
    async (_, { rejectWithValue }) => {
        try {
            return await markerNotificationsApi.fetchMarkerNotifications()
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Failed to load notifications'
            return rejectWithValue(message)
        }
    }
)

export const fetchMarkerNotificationHistory = createAsyncThunk(
    'markerNotifications/fetchHistory',
    async (_, { rejectWithValue }) => {
        try {
            return await markerNotificationsApi.fetchMarkerNotificationHistory()
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Failed to load notification history'
            return rejectWithValue(message)
        }
    }
)

export const dismissMarkerNotificationThunk = createAsyncThunk(
    'markerNotifications/dismiss',
    async (id: number, { rejectWithValue }) => {
        try {
            await markerNotificationsApi.dismissMarkerNotification(id)
            return id
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Failed to dismiss notification'
            return rejectWithValue(message)
        }
    }
)

export const resolveMarkerNotificationThunk = createAsyncThunk(
    'markerNotifications/resolve',
    async (params: { id: number; note?: string }, { rejectWithValue }) => {
        try {
            await markerNotificationsApi.resolveMarkerNotification(params.id, params.note)
            return params.id
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Failed to resolve notification'
            return rejectWithValue(message)
        }
    }
)

export const confirmPendingBookingThunk = createAsyncThunk(
    'markerNotifications/confirmPendingBooking',
    async (
        params: { bookingId: number; tableId: number; startTime: string; durationMinutes: number },
        { rejectWithValue }
    ) => {
        try {
            const { bookingId, ...request } = params
            return await bookingsApi.confirmPendingBooking(bookingId, request)
        } catch (error: unknown) {
            const message = error instanceof Error ? error.message : 'Failed to confirm booking'
            return rejectWithValue(message)
        }
    }
)
